<template>
  <div class="voting-controls voting-controls-lg clearfix">
    <button
      :class="['control', 'vote-button', 'vote', { voted: voted }]"
      @click.prevent="voted++"
    >
      <i
        :class="[
          'af-icons',
          { 'af-icons-vote': !voted },
          { 'af-icons-voted': voted }
        ]"
      ></i>
      <span v-if="voted">
        {{ lang.get('voting.controls.voted') }} +{{ voted }}
      </span>
      <span v-else>
        {{ stripTags(lang.get('voting.controls.vote')) }}
      </span>
    </button>
  </div>
</template>

<script>
import { stripTags } from '@/lib/string';

export default {
  inject: ['lang'],
  data() {
    return {
      voted: 0
    };
  },
  methods: {
    stripTags
  }
};
</script>
